import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../../../dynamicFormBuilder/FormField'
import { GenerateItemTasksLayout } from '../Layout';
function GenerateItemTasksRecordsTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const combinedLayouts = [
        { name: 'GenerateItemTasksLayout', layout: GenerateItemTasksLayout },
    ];
    const updatedLayouts = combinedLayouts.map(({ name, layout }) => {
        if (name !== 'GenerateItemTasksLayout') {
            return layout.map(group => ({
                ...group,
                label: "", 
                fields: group.fields.map(field => ({
                    ...field,
                    visible: false
                }))
            }));
        }
        return layout;
    });
    const finalLayout = updatedLayouts.flat();
    const handleGenerateItemTasksRecordsFormLoad = useCallback(() => {
        props.primaryFormLookupsLoad();
    }, []);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='DC0E2EC0-37FE-4E4A-9155-CD7AE85F1862'
                layoutName='GenerateItemTasksRecordsForm'
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handleGenerateItemTasksRecordsFormLoad}
                handleSelectedItemChange={props.handleSelectionChange}
            />

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(GenerateItemTasksRecordsTab);
